import { Flex, Text } from "@chakra-ui/react";
import { useTranslation, Trans } from "react-i18next";
import { H2, BodyText, Caption } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import FullScreen from "src/atoms/FullScreen";
import openExternal from "src/utils/openExternal";

const OptionNumber = ({ children, ...rest }) => (
  <Flex
    justifyContent="center"
    alignItems="center"
    flex="0 0 auto"
    borderRadius="100%"
    bg="primary"
    color="white"
    fontSize="10px"
    fontWeight="bold"
    letterSpacing="0.2px"
    width="16px"
    height="16px"
    {...rest}
  >
    {children}
  </Flex>
);

export default function NoStationFound() {
  const { t } = useTranslation();
  return (
    <>
      <FullScreen>
        <SceneLayout
          centerProps={{ width: "320px" }}
          center={
            <>
              <H2 mt="8px" textAlign="center" color="highEmphasis">
                {t("parentStation.lookingForStations.notFoundButton")}
              </H2>
              <BodyText mr="8px" color="mediumEmphasis">
                {t("parentStation.noStation.help.title")}
              </BodyText>
              <Flex mt="16px" alignItems="baseline">
                <OptionNumber mr="8px">1</OptionNumber>
                <BodyText color="mediumEmphasis">
                  {t("parentStation.noStation.help.text1")}
                </BodyText>
              </Flex>
              <Flex mt="16px" alignItems="baseline">
                <OptionNumber mr="8px">2</OptionNumber>
                <BodyText color="mediumEmphasis">
                  {t("parentStation.noStation.help.text2")}
                </BodyText>
              </Flex>
              <Flex mt="16px" alignItems="baseline">
                <OptionNumber mr="8px">3</OptionNumber>
                <BodyText color="mediumEmphasis">
                  {t("parentStation.noStation.help.text3")}
                </BodyText>
              </Flex>
            </>
          }
          bottomProps={{ pb: "18px" }}
          bottom={
            <Caption color="mediumEmphasis">
              <Trans i18nKey="parentStation.noStation.help.contact">
                If the issue persists,
                <Text
                  onClick={() => openExternal({ env: "EMAIL" })}
                  as="span"
                  cursor="pointer"
                  textDecoration="underline"
                  color="primary"
                  _hover={{ color: "primaryLighter" }}
                  _active={{ color: "primaryDarker" }}
                >
                  contact our support.
                </Text>
              </Trans>
            </Caption>
          }
        />
      </FullScreen>
    </>
  );
}
